<div class="global-loader" *ngIf="isLoading$ | async">
  <div class="loader-content">
    <div class="spinner"></div>
    <div>Please wait...</div>
  </div>
</div>